export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SERVICE_STATES = {
  "06": { abbr: "CA", name: "California", commodity: "Natural Gas" },
  "09": { abbr: "CT", name: "Connecticut", commodity: "Electricity & Natural Gas" },
  "10": { abbr: "DE", name: "Delaware", commodity: "Electricity & Natural Gas" },
  "13": { abbr: "GA", name: "Georgia", commodity: "Natural Gas" },
  "17": { abbr: "IL", name: "Illinois", commodity: "Electricity & Natural Gas" },
  "23": { abbr: "ME", name: "Maine", commodity: "Electricity & Natural Gas" },
  "24": { abbr: "MD", name: "Maryland", commodity: "Electricity & Natural Gas" },
  "25": { abbr: "MA", name: "Massachusetts", commodity: "Electricity & Natural Gas" },
  "33": { abbr: "NH", name: "New Hampshire", commodity: "Electricity & Natural Gas" },
  "34": { abbr: "NJ", name: "New Jersey", commodity: "Electricity & Natural Gas" },
  "36": { abbr: "NY", name: "New York", commodity: "Electricity & Natural Gas" },
  "39": { abbr: "OH", name: "Ohio", commodity: "Electricity & Natural Gas" },
  "42": { abbr: "PA", name: "Pennsylvania", commodity: "Electricity & Natural Gas" },
  "44": { abbr: "RI", name: "Rhode Island", commodity: "Electricity & Natural Gas" },
  "48": { abbr: "TX", name: "Texas", commodity: "Electricity" },
  "51": { abbr: "VA", name: "Virginia", commodity: "Electricity & Natural Gas" },
};

export const STATE_OPTIONS = Object.values(SERVICE_STATES)
  .map((s) => ({ abbr: s.abbr, name: s.name }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const HERO_VIDEOS = ["/videos/hero-1.mp4", "/videos/hero-2.mp4", "/videos/hero-3.mp4", "/videos/hero-4.mp4", "/videos/hero-5.mp4"];
export const HERO_POSTER = "/videos/hero-poster.jpg";

export const SUPPLIERS = [
  { name: "AEP Energy", logo: "/suppliers/aep-energy.png" },
  { name: "APG&E", logo: "/suppliers/apge.png" },
  { name: "Champion Energy Services", logo: "/suppliers/champion-energy.png" },
  { name: "Constellation", logo: "/suppliers/constellation.png" },
  { name: "Direct Energy", logo: "/suppliers/direct-energy.png" },
  { name: "Dynegy", logo: "/suppliers/dynegy.png" },
  { name: "ENGIE", logo: "/suppliers/engie.png" },
  { name: "Freepoint Energy Solutions", logo: "/suppliers/freepoint.png" },
];

export const SAVINGS_CASES = [
  { id: "il-distribution-warehouse", icon: "factory", title: "Illinois Distribution Warehouse", state: "IL", savings: 14320, usage: "510,000 kWh annual usage", commodity: "Electricity" },
  { id: "ny-medical-office", icon: "building", title: "New York Medical Office Building", state: "NY", savings: 6780, usage: "84,500 kWh annual usage", commodity: "Electricity" },
  { id: "tx-cold-storage", icon: "snowflake", title: "Texas Cold-Storage Logistics", state: "TX", savings: 18450, usage: "420,000 kWh annual usage", commodity: "Electricity" },
  { id: "pa-manufacturing", icon: "factory", title: "Pennsylvania Manufacturing Facility", state: "PA", savings: 34800, usage: "980,000 kWh annual usage", commodity: "Electricity" },
  { id: "ma-restaurant-group", icon: "utensils", title: "Massachusetts Restaurant Group", state: "MA", savings: 9150, usage: "38,500 Therms annual usage", commodity: "Natural Gas" },
  { id: "oh-office-park", icon: "building", title: "Ohio Commercial Office Park", state: "OH", savings: 27600, usage: "650,000 kWh annual usage", commodity: "Electricity" },
];

export const SPEND_OPTIONS = [
  { id: "under-5k", label: "Under $5,000" },
  { id: "5k-20k", label: "$5,000 – $20,000" },
  { id: "20k-50k", label: "$20,000 – $50,000" },
  { id: "50k-plus", label: "Over $50,000" },
];

export const FAQS = [
  {
    q: "What is energy deregulation, and how does it save my business money?",
    a: "In deregulated energy markets, your business can choose who supplies its electricity or natural gas instead of automatically buying from the local utility. The utility still delivers energy, maintains the lines, and responds to outages. Only the supply portion of your bill is opened to competition. Competing licensed suppliers offer different rates and contract terms, and that competition is where savings come from.",
  },
  {
    q: "Will switching suppliers interrupt my service or change my utility?",
    a: "No. Your local utility continues to deliver your energy, maintain infrastructure, read your meter, and respond to outages exactly as before. The only change is the supply rate on your bill. There is no equipment to install, no downtime, and no new infrastructure. Everything stays the same, but you pay a better rate than before.",
  },
  {
    q: "What is the difference between a fixed-rate and a variable-rate contract?",
    a: "A fixed-rate contract locks in a defined supply price for a set term (typically 12–36 months), protecting your budget from market spikes and making costs predictable. A variable rate moves with the market. It can be cheaper when prices fall but exposes you to increases. We help you weigh the trade-offs based on your usage pattern and risk tolerance.",
  },
  {
    q: "How much does BlueSettle charge for its services?",
    a: "For standard procurement services, there is no upfront consulting fee. BlueSettle is compensated through supplier-paid commissions when an eligible supply contract is successfully placed. This compensation may be reflected in contracted pricing, and we disclose applicable arrangements clearly before you sign anything.",
  },
  {
    q: "When should I start looking at my energy contract renewal?",
    a: "Ideally 3–6 months before your current contract expires. Many commercial agreements auto-renew onto costly variable rates if you miss the window. Depending on your market and supplier terms, we can often secure future pricing well before your existing agreement ends, so you never roll into a default rate.",
  },
  {
    q: "What information do you need to provide a quote?",
    a: "A recent utility bill is usually all we need to start. It shows your consumption levels, current supply rate, and billing structure. If you have an existing supplier agreement, the contract end date and any early termination provisions help us time the procurement correctly.",
  },
];

export const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const getUtm = () => {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source") || "",
    utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "",
  };
};
